import PotacoLogo from './Resources/PotacoStudioLogoBlue.png';
import MageFarm from './Resources/magefarm.png';
import Bluma from './Resources/bluma.png';
import Keety from './Resources/keety.png';
import FamilyPhoto from './Resources/familyphoto.png';
import SteamLogo from './Resources/steamlogo.png';
import AppStoreLogo from './Resources/appstore.svg';
import { SocialIcon } from 'react-social-icons'
import NightSky from './NightSky';
import Firefly from './Firefly'; // eslint-disable-line no-unused-vars
import './App.scss';

function App() {
  const blumaUrl = 'https://store.steampowered.com/app/3032520/BLUMA/';
  const keetyUrl = 'https://apps.apple.com/us/app/keety/id1131054781';
  const mageFarmSteamUrl = 'https://store.steampowered.com/app/4594090/Mage_Farm/';

  return (
    <div className="app">
      <NightSky />

      <div className='header'>
        <img className='potaco-logo' src={PotacoLogo} alt='Potaco Studio' />
        <p className='title'>POTACO STUDIO</p>
        <div className='icons'>
          <SocialIcon url="https://discord.gg/52rkgFNe5Q" target="_blank" rel="noopener noreferrer" />
          <SocialIcon url="https://www.youtube.com/@PotacoStudio" target="_blank" rel="noopener noreferrer" />
          <SocialIcon url="https://www.tiktok.com/@natthetacocat" target="_blank" rel="noopener noreferrer" />
          <SocialIcon url="https://bsky.app/profile/potacostudio.bsky.social" target="_blank" rel="noopener noreferrer" />
          <SocialIcon url="mailto:nat@potaco.studio" />
        </div>
      </div>

      <main className='content'>
        <section className='hero mage-farm'>
          <img className='game-image' src={MageFarm} alt='MageFarm' />
          <h3 className='game-title'>Mage Farm</h3>
          <p className='game-subtitle'>
            Farm together, fight together!
          </p>
          <p className='game-description'>
            Join with friends locally or online to grow fantastical crops, brew powerful potions, and defend your farm.
          </p>
          <button className='game-link' onClick={() => window.open(mageFarmSteamUrl, '_blank', 'noopener,noreferrer')}>
            <p>Wishlist Now</p>
            <img className='steam-icon' src={SteamLogo} alt='Steam icon' />
          </button>
        </section>

        <section className='other-games'>
          <div className='game-grid'>
            <article className='game-card bluma'>
              <img className='game-image' src={Bluma} alt='BLUMA' />
              <h3 className='game-title'>BLUMA</h3>
              <p className='game-subtitle'>Cozy puzzle-platforming adventure</p>
              <p className='game-description'>It’s up to Bluma, a magical chinchilla, to unite the elemental realms by solving physics-based puzzles and farming vegetables.</p>
              <button className='game-link' onClick={() => window.open(blumaUrl, '_blank', 'noopener,noreferrer')}>
                <p>Available Now</p>
                <img className='steam-icon' src={SteamLogo} alt='Steam icon' />
              </button>
            </article>

            <article className='game-card keety'>
              <img className='game-image' src={Keety} alt='Keety' />
              <h3 className='game-title'>Keety</h3>
              <p className='game-subtitle'>Arcade action-shooter inspired by cat memes</p>
              <p className='game-description'>How many keeties can YOU cheese?</p>
              <button className='game-link' onClick={() => window.open(keetyUrl, '_blank', 'noopener,noreferrer')}>
                <img className='appstore-icon' src={AppStoreLogo} alt='App Store icon' />
              </button>
            </article>
          </div>
        </section>

        <section className='about'>
          <img className='family-photo game-image' src={FamilyPhoto} alt='Potaco Studio team' />
          <h3 className='game-title'>About Us</h3>
          <p className='game-subtitle'>Potaco Studio is a small indie game studio located in Northern Virginia, USA.</p>
          <p className='game-description'>We are a wife and wife team who enjoy making cute and silly games.</p>
        </section>
      </main>
    </div>
  );
}

export default App;
